import { FC } from 'react'
import Skeleton from '@components/skeleton'
import { SkeletonTable } from '@components/skeleton-table'
import {
    FilterButton,
    Search,
    SearchFilterSection,
    SkeletonContent,
    Title,
    TitleSection,
} from '@components/skeleton-table/skeletonTable.styles'
import { FraudDefenseLoadingProps } from './FraudDefenseLoading.types'

const DEFAULT_COLUMN_COUNT = 5
const DEFAULT_ROW_COUNT = 8

const FraudDefenseLoading: FC<FraudDefenseLoadingProps> = ({
    columnCount = DEFAULT_COLUMN_COUNT,
    rowCount = DEFAULT_ROW_COUNT,
}) => {
    return (
        <Skeleton>
            <SkeletonContent data-testid="fraud-defense-loading">
                <TitleSection>
                    <Title />
                </TitleSection>
                <SearchFilterSection>
                    <Search />
                    <FilterButton />
                </SearchFilterSection>
                <SkeletonTable
                    columnCount={columnCount}
                    rowCount={rowCount}
                    testIdPrefix="fraud-defense-skeleton"
                />
            </SkeletonContent>
        </Skeleton>
    )
}

export default FraudDefenseLoading
